import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/kid_star.svg'
import _imports_1 from '@/assets/icons/warn.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-141c6a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "providers-list" }
const _hoisted_2 = { class: "listing-titles" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "recommended" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "savings-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Warning"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentProviderItem = _resolveComponent("PaymentProviderItem")!
  const _component_BottomBar = _resolveComponent("BottomBar")!
  const _component_HighlightPopup = _resolveComponent("HighlightPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("PaymentsProvidersView-HowToPay")), 1),
      (_ctx.filteredProviders[0].length !== 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.displayNoCommissionBanner === true)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Sin comisión")), 1),
                  _createElementVNode("span", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("in-store-cash-Smallest-Recommended")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProviders[0], (provider) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: provider.name
                }, [
                  _createVNode(_component_PaymentProviderItem, {
                    "payment-provider": provider,
                    onSelectPaymentProvider: _ctx.handleSelectPaymentProvider
                  }, null, 8, ["payment-provider", "onSelectPaymentProvider"])
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.filteredProviders[1].length !== 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Con comisión")), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProviders[1], (provider) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: provider.name
                }, [
                  _createVNode(_component_PaymentProviderItem, {
                    "payment-provider": provider,
                    onSelectPaymentProvider: _ctx.handleSelectPaymentProvider
                  }, null, 8, ["payment-provider", "onSelectPaymentProvider"])
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_BottomBar, {
      text: _ctx.$t('PaymentsProvidersView-PaymentAmount'),
      amount: _ctx.amount,
      "currency-symbol": _ctx.currencySymbol,
      "term-label": _ctx.$t(_ctx.term),
      onChangePaymentAmount: _ctx.handleAmountChange
    }, null, 8, ["text", "amount", "currency-symbol", "term-label", "onChangePaymentAmount"]),
    _createVNode(_component_HighlightPopup, {
      "is-visible": _ctx.onHighlighted,
      onClosePopup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClosePopup('highLight')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("Popup-Pay-Without-Commissions")), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Popup-Save-Money-Using-These-Options")), 1),
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlightedProviders, (provider) => {
            return (_openBlock(), _createElementBlock("li", {
              key: _ctx.$t(provider.name),
              class: "savings"
            }, [
              _createElementVNode("img", {
                src: provider.logo,
                alt: provider.displayName
              }, null, 8, _hoisted_7)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedProviders, (group, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
        (group.length > 0)
          ? (_openBlock(), _createBlock(_component_HighlightPopup, {
              key: 0,
              "is-visible": _ctx.showWarningPopUp,
              onClosePopup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClosePopup('warning')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _createElementVNode("h1", null, _toDisplayString(group[0].title1), 1),
                  _createElementVNode("h1", null, _toDisplayString(group[0].title2), 1),
                  _createElementVNode("p", null, _toDisplayString(group[0].reason_text), 1)
                ])
              ]),
              _: 2
            }, 1032, ["is-visible"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 64))
}